import { axiosInstance } from "./axiosInstance";
const login = (data) => axiosInstance.post(`login-post` , data)
const logout = (data) => axiosInstance.post(`logout` , data)

export {login , logout}
